import { render, staticRenderFns } from "./PolicyCostView.vue?vue&type=template&id=ec95f43e&scoped=true&"
import script from "./PolicyCostView.vue?vue&type=script&lang=js&"
export * from "./PolicyCostView.vue?vue&type=script&lang=js&"
import style0 from "./PolicyCostView.vue?vue&type=style&index=0&id=ec95f43e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec95f43e",
  null
  
)

export default component.exports